import { EventAggregator } from 'aurelia-event-aggregator';
import { LoginController } from '../../controllers/login-controller'
import { Router } from 'aurelia-router';
import { computedFrom, newInstance, autoinject } from 'aurelia-framework';
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger, Validator } from 'aurelia-validation';
import { DefaultValidationRenderer } from "../../resources/renderers/default-validation-renderer";
import { PageMessageService } from "../../services/page-message-service";
import { WebApiService } from "../../services/web-api-service";
import { SecurityService } from '../../services/security-service';
import { BusyService } from '../../services/busy-service';
import * as moment from 'moment';
import { NewUserRequestSubmitDto } from '../../data/typegen/dtos/new-user-request-submit-dto';
import { RequestDto } from '../../data/typegen/dtos/request-dto';

@autoinject
export class NoUserAccount {
    requestSent: boolean;
    accountRequestedDate: any;
    emailAddress: string;
    subscription: any;
    isLocalUserSignup: boolean;
    firstName: any;
    lastName: any;
    pageTitle: string;
    recaptchaResponse: string;
    emailAlreadyExists: boolean;
    accountRequestedSuccessful: boolean;

    constructor(private router: Router,
        private busyService: BusyService,
        private eventAggregator: EventAggregator,
        //public loginController: LoginController,
        private api: WebApiService,
        private security: SecurityService,
        @newInstance() private controller: ValidationController,
        private pageMessageService: PageMessageService) {

        this.controller.validateTrigger = validateTrigger.change;
        controller.addRenderer(new DefaultValidationRenderer());

        this.eventAggregator.subscribe("router:navigation:success", this.navigationSuccess.bind(this))

    }


    @computedFrom("emailAddress")
    get shouldSignIntoAuth0(): boolean {
        //TODO: Get this list dynamically from the connections: https://nucor.auth0.com/api/v2/connections?strategy=waad
        // This should be the same list as:  https://manage.auth0.com/dashboard/us/nucor/connections/enterprise/waad/con_lCRmc5cQI6t2H03K/setup
        var ssoEmailDomains = [
            "nucor.onmicrosoft.com",
            "nucor.com",
            "fibonaccisolutions.com",
            "skylinesteel.com",
            "nucor-yamato.com",
            "stlcd.com",
            "vulcraft-al.com",
            "vulcraft-in.com",
            "vulcraft-ne.com",
            "vulcraft-ny.com",
            "vulcraft-sc.com",
            "vulcraft-ut.com",
            "vulcraft-tx.com",
            "americanbuildings.com",
            "nbssc.com",
            "nbstx.com",
            "nbsut.com",
            "vercodeck.com",
            "nucorskyline.com",
            "barometer.nucor.com"
        ];

        // the purpose of this logic is that users who are using SSO-enabled emails - they should log into CMP first using Auth0 and THEN complete the signup process.
        // this eliminates a lot of data risk during the signup process.

        const email = (this.emailAddress || "").toLowerCase();
        const parts = email.split("@");
        const emailDomain = parts[1];
        if (this.isLocalUserSignup == true && ssoEmailDomains.indexOf(emailDomain) > -1) {
            return true;
        }
        return false;
    }

    logout() {
        (<any>window.location) = "logout";
    }
    login() {
        (<any>window.location) = "login";
    }

    public signupType = "";

    async navigationSuccess(event) {
        let instruction = event.instruction;
        if (instruction.config.name == "signup") {
            // this path is for users who click the "Signup" link on the main landing page
            this.pageTitle = "New User Sign-up";
            this.recaptchaResponse = "";
            this.isLocalUserSignup = true;
        } else {
            // this path is for new users who login, but do not have a CMP account.
            this.isLocalUserSignup = false;
            await this.security.init();
            this.firstName = this.security.user.firstName;
            this.lastName = this.security.user.lastName;
            this.emailAddress = this.security.user.emailAddress;
            this.isUserInactive = !this.security.user.active;
            this.accountRequestedDate = await this.getAccountRequestedDate();
            this.requestSent = !!this.accountRequestedDate;
            this.pageTitle = this.isUserInactive ? "Account Inactive" : "Request an Account";
            this.recaptchaResponse = "NOT_NEEDED"; // we don't use the recaptcha for authenticated users, so add fake value to pass local validation
        }
    }

    detached() {
        this.subscription.dispose();
    }

    async activate(parameters) {
    }

    private getAccountRequestedDate(): any {
        this.busyService.on();
        return this.api.get("Auth", "GetAccountRequestedDate")
            .then((result) => {
                var request = JSON.parse(result.response) as RequestDto;
                return !!request ? moment(request.openedOn).format("LLLL") : "";
            }).finally(() => this.busyService.off());
    }


    public isUserInactive: boolean = false;
    public division: string;
    public additionalDivisions: string;
    public phone: string;

    async submit() {
        this.accountRequestedSuccessful = false;
        this.controller.validate().then(async v => {
            if (v.length === 0) {
                this.pageMessageService.clear();
                const dto: NewUserRequestSubmitDto = {
                    division: this.division,
                    additionalDivisions: this.additionalDivisions,
                    phone: this.phone,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    emailAddress: this.emailAddress,
                    recaptchaResponse: this.recaptchaResponse,
                    auth0UserId: "",
                    fullName: ""
                };

                let action = "InsertUserAccountRequestWithRecaptcha";
                if (this.security.hasRole("cmp.noaccess")) {
                    action = "InsertUserAccountRequest";
                }
                try {
                    const responseMessage = await this.api.post("Auth", action, dto);
                    const requestDto:RequestDto = JSON.parse(responseMessage.response) as RequestDto;
                    this.accountRequestedSuccessful = true;
                    this.pageMessageService.setInfoMessage("Your account has been requested.  Please save this request number for reference: " + requestDto.number);
                    this.requestSent = true;

                    // if (result.status == "success") {
                    //     this.accountRequestedSuccessful = true;
                    //     this.pageMessageService.setInfoMessage("Account request successful!");
                    // } else if (result.status == "pending_request") {
                    //     this.accountRequestedDate = result.accountRequestedDate;
                    //     this.pageMessageService.setErrorMessage("Account already requested");
                    // } else if (result.status == "already_exists") {
                    //     this.emailAlreadyExists = true;
                    //     this.pageMessageService.setErrorMessage("User already exists");
                    // }
                    // else {
                    //     this.pageMessageService.setErrorMessage("Account request not completed!");
                    // }
                } catch (e) {
                    this.pageMessageService.setErrorMessage(e.message || e.errorMessage || JSON.stringify(e));
                    //this.pageMessageService.setErrorMessage("Error: " + e.errorMessage);
                }finally{
                    this.recaptchaResponse = "";
                    window["grecaptcha"].reset();
                }
            }
            else {
                this.pageMessageService.setDefaultValidationMessage();
            }
        });
    }

    recaptcha(response) {
        //alert(response);
        this.recaptchaResponse = response;
    }


}


ValidationRules
    .ensure((m: NoUserAccount) => m.firstName).required().maxLength(255)
    .ensure((m: NoUserAccount) => m.lastName).required().maxLength(255)
    .ensure((m: NoUserAccount) => m.emailAddress).email().required().maxLength(255)
    .ensure((m: NoUserAccount) => m.division).required().maxLength(255)
    .ensure((m: NoUserAccount) => m.additionalDivisions).maxLength(255)
    .ensure((m: NoUserAccount) => m.phone).required().maxLength(20)
    .ensure((m: NoUserAccount) => m.recaptchaResponse).required().withMessage('Please verify that you are not a robot.')
    .on(NoUserAccount);

